import Tires from 'pages/CatalogPage/DH/Tires/Tires';

export default Tires;
